import {useContext} from "react";
import MobileTableContext from "./MobileTableContext";
import {MobileTableContextData} from "./MobileTableContextData";

export default function useMobileTableContext(): MobileTableContextData {
    return useContext<MobileTableContextData>(MobileTableContext);
}
